module.exports = "<div class=\"divIdiomasPage\">\n    <div class=\"divLenImg\" (click)=\"idioma('es')\"> <img src=\"../assets/imgs/es2.png\" class=\"imgLen\"> </div>\n    <div class=\"divLenImg\" (click)=\"idioma('en')\"> <img src=\"../assets/imgs/en2.png\" class=\"imgLen\"> </div>\n</div>\n\n<div class=\"aviso\" *ngIf=\"showAviso\">\n    {{ 'IDIOMAS.change' | translate }}\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/idiomas/idiomas.component.html
// module id = ./src/app/idiomas/idiomas.component.html
// module chunks = main